import { ChunkReloadStatus, STORAGE_CHUNK_RELOAD_FLAG } from "globalConstants/storage";

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return (
    error.name === "ChunkLoadError" ||
    error.message.includes("Failed to fetch dynamically imported module") ||
    error.message.includes("Unable to preload CSS")
  );
}

export function triggerChunkReload(): void {
  sessionStorage.setItem(STORAGE_CHUNK_RELOAD_FLAG, ChunkReloadStatus.PENDING);
  window.location.reload();
}
